import React, { useEffect, useRef, useState } from "react";
import { checkProblemStatement } from "../api";
import { fingerprintStatement } from "../utils/problemStatementMeta";
import DuplicateStatementNotice from "./DuplicateStatementNotice";

/**
 * Watches the problem statement text and, when someone already has the same
 * problem, shows a reminder with name / department / year. Never blocks.
 */
export default function ProblemDuplicateWatcher({ text = "", onChooseDifferent }) {
  const [matches, setMatches] = useState([]);
  const [ackFp, setAckFp] = useState("");
  const timer = useRef(null);
  const seq = useRef(0);

  useEffect(() => {
    clearTimeout(timer.current);
    const clean = String(text || "").trim();
    if (clean.length < 20) {
      setMatches([]);
      return undefined;
    }
    timer.current = setTimeout(async () => {
      const mine = ++seq.current;
      try {
        const res = await checkProblemStatement(clean.slice(0, 80), clean);
        if (mine !== seq.current) return;
        setMatches(res?.exists ? res.matches || [] : []);
      } catch {
        if (mine === seq.current) setMatches([]);
      }
    }, 900);
    return () => clearTimeout(timer.current);
  }, [text]);

  const fp = fingerprintStatement(text);
  if (!matches.length || (ackFp && ackFp === fp)) return null;

  return (
    <DuplicateStatementNotice
      matches={matches}
      onUseSame={() => setAckFp(fp)}
      onChooseDifferent={() => {
        setMatches([]);
        onChooseDifferent?.();
      }}
      onDismiss={() => setAckFp(fp)}
    />
  );
}
